import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { seperationActions } from "../../store/SeperationSlice";
import { submitExitInterview } from "../../store/SeperationSlice/thunk";
import BackIcon from "../../assets/icons/arrow_back.svg";
import SubmitIcon from "../../assets/icons/inventory.svg";
import CheckIconGrey from "../../assets/icons/check-grey.svg";
import CloseIconGrey from "../../assets/icons/close_grey.svg";
import MaybeIcon from "../../assets/icons/rule.svg";
import moment from "moment";
import "./SeprerationExitForm.css";
import { getAllTaskboxItems } from "../../store/TaskboxSlice/thunk";

const SeprerationExitForm = () => {
  const [isError, setIsError] = useState(false);
  const [exitInterviewQuestions, setExitInterviewQuestions] = useState({
    satisfiedWithGrowth: "",
    supportByManagerDuringStint: "",
    recommendCompanyToOthers: "",
    nextEmployerName: "",
    incrementReceivedByNextEmployer: "",
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const empData = useSelector(
    (state) => state?.seperation?.exitEmployeeDetails
  );

  const exitInterviewSubmitResponse = useSelector(
    (state) => state?.seperation?.exitInterviewSubmitResponse
  );
  const exitInterviewSubmitResponseStatus = useSelector(
    (state) => state?.seperation?.exitInterviewSubmitResponseStatus
  );

  useEffect(() => {
    console.log("Employee Data:", empData);
    return () => {
      dispatch(seperationActions.setExitEmployeeDetails(null));
    };
  }, [empData]);

  useEffect(() => {
    if (exitInterviewSubmitResponseStatus === "SUCCESS") {
      console.log(
        "\n\n\n\n\n\n Separation Approval exitInterviewSubmitResponse : ",
        exitInterviewSubmitResponse
      );

      dispatch(
        getAllTaskboxItems({
          offset: 0,
          limit: 1,
          request_type: "taskbox",
        })
      );

      navigate("./seperation");
    } else if (exitInterviewSubmitResponseStatus === "ERROR") {
      console.log(
        "\n\nexitInterviewSubmitResponse : ",
        exitInterviewSubmitResponse
      );
    }
  }, [exitInterviewSubmitResponseStatus]);

  const areAllValuesEmpty = (obj) => {
    if (!obj || typeof obj !== "object") return true; // Ensure the input is a valid object
    return Object.values(obj).every((value) => value === "");
  };

  const handleExitInterviewFields = (data) => {
    const obj = {
      satisfiedWithGrowth: data.satisfiedWithGrowth,
      supportByManagerDuringStint: data.supportByManagerDuringStint,
      recommendCompanyToOthers: data.recommendCompanyToOthers,
      nextEmployerName: data.nextEmployerName,
      incrementReceivedByNextEmployer: data.incrementReceivedByNextEmployer,
    };
    setExitInterviewQuestions((prev) => ({ ...prev, ...obj }));
  };

  const approveButtonHandler = () => {
    console.log("\nRequest submitted");

    const payload = {
      employee_id: empData?.employee_id,
      // request_type: "Exit Interview Form",
    };

    let data = {
      satisfied_with_growth: exitInterviewQuestions.satisfiedWithGrowth,
      support_by_manager_during_stint:
        exitInterviewQuestions.supportByManagerDuringStint,
      recommend_company_to_others:
        exitInterviewQuestions.recommendCompanyToOthers,
      next_employer_name: exitInterviewQuestions.nextEmployerName,
      increment_received_by_next_employer:
        exitInterviewQuestions.incrementReceivedByNextEmployer,
      approved_date: moment(new Date()).format("YYYY-MM-DD"),
    };
    payload.exit_interview = JSON.stringify(data);

    console.log("Payload to for submit :\n\n", empData, payload);

    dispatch(submitExitInterview(payload));
  };

  return (
    <div className="sp-home">
      <div className="flex justify-between w-full">
        <div className="flex items-center">
          <img
            src={BackIcon}
            alt="icon"
            className="rq-home-btn-ico mr-2 cursor-pointer"
            onClick={() => navigate("./seperation")}
          />

          <div className="sp-head">exit interview form</div>
        </div>
        <div className="flex">
          <button
            className="btn p-btn p-btn-og"
            onClick={() => approveButtonHandler()}
            disabled={areAllValuesEmpty(exitInterviewQuestions)}
          >
            <img className="p-btn-icon" src={SubmitIcon} alt="" />
            <div className="p-btn-text">Submit</div>
          </button>
        </div>
      </div>
      <div className="flex flex-col">
        <div
          className={`flex flex-col question-box-common align-items-flex-start w-fit-content ${
            exitInterviewQuestions?.satisfiedWithGrowth === "" &&
            isError &&
            "error-border"
          }`}
        >
          <div className="work-label">
            Were you satisfied with the growth opportunities within the role in
            the company?*
          </div>
          <div className="flex">
            <div
              className="flex items-center work-check-box"
              style={{
                border:
                  exitInterviewQuestions.satisfiedWithGrowth === "Yes"
                    ? "2px solid #172128"
                    : "none",
              }}
              onClick={() =>
                handleExitInterviewFields({
                  ...exitInterviewQuestions,
                  satisfiedWithGrowth: "Yes",
                })
              }
            >
              <img className="work-icon" src={CheckIconGrey} alt="work-icon" />
              <div className="work-check-label">Yes</div>
            </div>
            <div
              className="flex items-center work-check-box"
              style={{
                border:
                  exitInterviewQuestions.satisfiedWithGrowth === "No"
                    ? "2px solid #172128"
                    : "none",
              }}
              onClick={() =>
                handleExitInterviewFields({
                  ...exitInterviewQuestions,
                  satisfiedWithGrowth: "No",
                })
              }
            >
              <img className="work-icon" src={CloseIconGrey} alt="work-icon" />
              <div className="work-check-label">No</div>
            </div>
            <div
              className="flex items-center work-check-box"
              style={{
                border:
                  exitInterviewQuestions.satisfiedWithGrowth === "Maybe"
                    ? "2px solid #172128"
                    : "none",
              }}
              onClick={() =>
                handleExitInterviewFields({
                  ...exitInterviewQuestions,
                  satisfiedWithGrowth: "Maybe",
                })
              }
            >
              <img className="work-icon" src={MaybeIcon} alt="work-icon" />
              <div className="work-check-label">Maybe</div>
            </div>
          </div>
        </div>
        <div
          className={`flex flex-col question-box-common align-items-flex-start w-fit-content ${
            exitInterviewQuestions?.supportByManagerDuringStint === "" &&
            isError &&
            "error-border"
          }`}
        >
          <div className="work-label">
            Did your manager guide and support you well during your stint?*
          </div>
          <div className="flex">
            <div
              className="flex items-center work-check-box"
              style={{
                border:
                  exitInterviewQuestions.supportByManagerDuringStint === "Yes"
                    ? "2px solid #172128"
                    : "none",
              }}
              onClick={() =>
                handleExitInterviewFields({
                  ...exitInterviewQuestions,
                  supportByManagerDuringStint: "Yes",
                })
              }
            >
              <img className="work-icon" src={CheckIconGrey} alt="work-icon" />
              <div className="work-check-label">Yes</div>
            </div>
            <div
              className="flex items-center work-check-box"
              style={{
                border:
                  exitInterviewQuestions.supportByManagerDuringStint === "No"
                    ? "2px solid #172128"
                    : "none",
              }}
              onClick={() =>
                handleExitInterviewFields({
                  ...exitInterviewQuestions,
                  supportByManagerDuringStint: "No",
                })
              }
            >
              <img className="work-icon" src={CloseIconGrey} alt="work-icon" />
              <div className="work-check-label">No</div>
            </div>
            <div
              className="flex items-center work-check-box"
              style={{
                border:
                  exitInterviewQuestions.supportByManagerDuringStint === "Maybe"
                    ? "2px solid #172128"
                    : "none",
              }}
              onClick={() =>
                handleExitInterviewFields({
                  ...exitInterviewQuestions,
                  supportByManagerDuringStint: "Maybe",
                })
              }
            >
              <img className="work-icon" src={MaybeIcon} alt="work-icon" />
              <div className="work-check-label">Maybe</div>
            </div>
          </div>
        </div>
        <div className="flex flex-col question-box-common align-items-flex-start w-fit-content">
          <div className="work-label">
            Would you recommend this company to others?
          </div>
          <div className="flex">
            <div
              className="flex items-center work-check-box"
              style={{
                border:
                  exitInterviewQuestions.recommendCompanyToOthers === "Yes"
                    ? "2px solid #172128"
                    : "none",
              }}
              onClick={() =>
                handleExitInterviewFields({
                  ...exitInterviewQuestions,
                  recommendCompanyToOthers: "Yes",
                })
              }
            >
              <img className="work-icon" src={CheckIconGrey} alt="work-icon" />
              <div className="work-check-label">Yes</div>
            </div>
            <div
              className="flex items-center work-check-box"
              style={{
                border:
                  exitInterviewQuestions.recommendCompanyToOthers === "No"
                    ? "2px solid #172128"
                    : "none",
              }}
              onClick={() =>
                handleExitInterviewFields({
                  ...exitInterviewQuestions,
                  recommendCompanyToOthers: "No",
                })
              }
            >
              <img className="work-icon" src={CloseIconGrey} alt="work-icon" />
              <div className="work-check-label">No</div>
            </div>
            <div
              className="flex items-center work-check-box"
              style={{
                border:
                  exitInterviewQuestions.recommendCompanyToOthers === "YMaybees"
                    ? "2px solid #172128"
                    : "none",
              }}
              onClick={() =>
                handleExitInterviewFields({
                  ...exitInterviewQuestions,
                  recommendCompanyToOthers: "Maybe",
                })
              }
            >
              <img className="work-icon" src={MaybeIcon} alt="work-icon" />
              <div className="work-check-label">Maybe</div>
            </div>
          </div>
        </div>
        <div className="flex">
          <div className="flex flex-col form-detail">
            <div className="emp-form-label">Name of your Next Employer</div>
            <input
              className="emp-form-input"
              onChange={(e) => {
                handleExitInterviewFields({
                  ...exitInterviewQuestions,
                  nextEmployerName: e.target.value,
                });
              }}
            />
          </div>
          <div className="flex flex-col form-detail">
            <div className="emp-form-label">
              Percentage Increase Offered by your Next Employer 30% - 45%
            </div>
            <input
              className="emp-form-input"
              onChange={(e) => {
                handleExitInterviewFields({
                  ...exitInterviewQuestions,
                  incrementReceivedByNextEmployer: e.target.value,
                });
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default SeprerationExitForm;
